
import { Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { BeadItems } from '../data-model'

export default class BeadSVG extends Vue {
    @Prop({ required: true }) mdata!: BeadItems
    @Prop() gameType!: string

    get isSuper6() {
        return this.mdata.isSuper6
    }

    get label(): string {
        let result = ''
        if (this.gameType === 'G002') {
            if (this.mdata.type === 0) result = '庄'
            else if (this.mdata.type === 1) result = '闲'
            else if (this.mdata.type === 2) result = '和'
        } else if (this.gameType === 'G003') {
            if (this.mdata.type === 0) result = '龙'
            else if (this.mdata.type === 1) result = '虎'
            else if (this.mdata.type === 2) result = '和'
        }

        return result
    }

    get fillColor(): string {
        if (this.mdata.type === 0) return '#c70004'
        else if (this.mdata.type === 1) return '#0000fe'
        else if (this.mdata.type === 2) return '#00c40c'

        return 'rgba(0,0,0,0)'
    }

    get hasRedpair(): boolean {
        return this.mdata.pair === 1 || this.mdata.pair === 3
    }

    get hasBluePair(): boolean {
        return this.mdata.pair === 2 || this.mdata.pair === 3
    }
}
